import { render } from "./RegistEmailModal.vue?vue&type=template&id=03f4c9d2&scoped=true&ts=true"
import script from "./RegistEmailModal.vue?vue&type=script&lang=ts"
export * from "./RegistEmailModal.vue?vue&type=script&lang=ts"

import "./RegistEmailModal.vue?vue&type=style&index=0&id=03f4c9d2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f4c9d2"]])

export default __exports__